import { render, staticRenderFns } from "./ResponseError.vue?vue&type=template&id=66560e5d&"
import script from "./ResponseError.vue?vue&type=script&lang=js&"
export * from "./ResponseError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports